var _circle, _path, _path2, _line, _path3, _line2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 369,
    viewBox: "0 0 290 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.833,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.367 214.827L147.094 183.586L188.297 214.827",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.074 103.363L78.2578 119.841V202.227L104.074 188.222V103.363Z",
    fill: "url(#paint1_linear_1486_9745)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109.126,
    y1: 99.6761,
    x2: 71.1448,
    y2: 122.541,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.59 103.363L205.406 119.841V202.227L179.59 188.222V103.363Z",
    fill: "url(#paint2_linear_1486_9745)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -3,
    x2: 47.3324,
    y2: -3,
    transform: "matrix(0.856727 0.515771 0.515771 -0.856727 173.945 95.5586)",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.668 314.086C118.668 317.239 117.632 320.085 115.558 322.624C113.506 325.163 110.723 327.258 107.211 328.908C103.72 330.537 99.8265 331.627 95.5312 332.177L93.4683 327.639C97.1499 327.194 100.525 326.327 103.593 325.036C106.661 323.724 109.083 322.116 110.861 320.212C112.659 318.286 113.559 316.245 113.559 314.086V312.246H118.668V314.086ZM119.748 314.086C119.748 316.245 120.636 318.286 122.414 320.212C124.212 322.116 126.645 323.724 129.713 325.036C132.781 326.327 136.156 327.194 139.838 327.639L137.743 332.177C133.469 331.627 129.565 330.527 126.032 328.876C122.519 327.226 119.726 325.142 117.653 322.624C115.579 320.085 114.542 317.239 114.542 314.086V312.246H119.748V314.086ZM142.567 340.207H90.707V335.256H142.567V340.207ZM135.998 358.425H102.926V364.614H96.9912V354.077H130.094V349.411H96.896V344.841H135.998V358.425ZM137.648 368.137H96.9912V363.471H137.648V368.137ZM198.744 344.587H146.884V339.731H198.744V344.587ZM193.888 318.752H151.645V313.833H193.888V318.752ZM193.634 334.621H151.898V329.765H193.634V334.621ZM165.927 332.907H159.928V315.864H165.927V332.907ZM185.604 332.907H179.574V315.864H185.604V332.907ZM192.428 367.978H153.104V349.951H192.428V367.978ZM159.071 363.09H186.525V354.648H159.071V363.09Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.833 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1FBE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_9745",
    x1: 91.166,
    y1: 103.363,
    x2: 91.166,
    y2: 202.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1486_9745",
    x1: 192.498,
    y1: 103.363,
    x2: 192.498,
    y2: 202.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionSad);
export default __webpack_public_path__ + "static/media/IconEmotionSad.9c94f6e16432c0524eb794bb1bd63a24.svg";
export { ForwardRef as ReactComponent };